import React from "react";
import Dropdown from "components/dropdown";
import { useTranslation } from "react-i18next";

const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "lv", label: "LV", name: "Latviešu" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  const setLang = async (code) => {
    await i18n.changeLanguage(code);
    localStorage.setItem("lang", code);
  };

  //tests in frontend

  return (
    <Dropdown
      button={
        <div className="flex cursor-pointer items-center gap-2 rounded-full px-2 py-1 text-sm font-medium text-gray-600 hover:bg-gray-100 dark:text-white dark:hover:bg-white/10">
          <span className="text-xs font-semibold">{current.label}</span>
        </div>
      }
      classNames={"py-2 top-8 -left-[40px] w-max"}
      animation="origin-top-left transition-all duration-200 ease-in-out"
      children={
        <div className="flex w-32 flex-col gap-1 rounded-[16px] bg-white p-2 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
          {LANGS.map((l) => {
            const active = l.code === current.code;
            return (
              <button
                key={l.code}
                onClick={() => setLang(l.code)}
                className={`flex w-full items-center justify-between rounded-xl px-3 py-2 text-sm transition ${
                  active
                    ? "bg-gray-100 font-semibold text-navy-700 dark:bg-white/10 dark:text-white"
                    : "text-gray-700 hover:bg-gray-100 dark:text-white/90 dark:hover:bg-white/10"
                }`}
              >
                <span>{l.name}</span>
                {active && <span className="text-xs opacity-70">✓</span>}
              </button>
            );
          })}
        </div>
      }
    />
  );
}
